import { LambdaTimeout } from '@shared/helpers'
import { ENDPOINT_IFP_APPLICATION_SEND_ACTION, IfpApplicationActionResponse } from '@shared/sec-loans'
import { isErrorResponse } from '@ui-common/utils'
import { callEndpoint } from '@ui-common/utils/http'
import { AnyActorRef, ErrorActorEvent, fromPromise, sendTo, setup } from 'xstate'

const SENDING = 'sending'

interface SendStepApplicationData {
  applicationId: string
  authCode: string
}

export const sendStepMachine = (parentService: AnyActorRef) => {
  return setup({
    types: {
      context: {} as SendStepApplicationData,
      input: {} as SendStepApplicationData,
    },
    actions: {
      sendSuccess: sendTo(parentService, (_: unknown, data: IfpApplicationActionResponse) => ({
        type: 'SEND_SUCCESS',
        data,
      })),
      sendFailed: sendTo(parentService, (_: unknown, error: unknown) => {
        return { type: 'SEND_FAILED', error: isErrorResponse(error) ? error : undefined }
      }),
    },
    actors: {
      submitIfpApplication: fromPromise(({ input }: { input: SendStepApplicationData }) => {
        return callEndpoint(ENDPOINT_IFP_APPLICATION_SEND_ACTION, {
          pathParams: { applicationId: input.applicationId },
          requestPayload: {
            authCode: input.authCode,
          },
          abortSignal: AbortSignal.timeout(LambdaTimeout.Max * 1000),
          requestConfig: {
            maxRetries: 0,
          },
        })
      }),
    },
  }).createMachine({
    initial: SENDING,
    context: ({ input }) => input,
    states: {
      [SENDING]: {
        invoke: {
          id: 'submitIfpApplication',
          src: 'submitIfpApplication',
          input: ({ context }) => context,
          onDone: {
            actions: {
              type: 'sendSuccess',
              params: ({ event }) => event.output,
            },
          },
          // TODO: DIG-6575 Improve error handling
          onError: {
            actions: [{ type: 'sendFailed', params: ({ event }: { event: ErrorActorEvent }) => event.error }],
          },
        },
      },
    },
  })
}
